"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function lbc(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M18.0852 12.9037L17.4874 12.7544L17.6689 12.0269L19.5327 12.4927L19.0677 14.3564L18.3394 14.1749L18.5007 13.5284L11.8467 17.6482L4.46741 13.9612V11.1472L12.1354 6.35168L19.1667 9.78143V10.9394L11.8474 15.4867L6.41216 12.7919L6.74516 12.1199L11.8069 14.6294L18.4167 10.5224V10.2502L12.1804 7.20818L5.21816 11.5627V13.4977L11.8084 16.7902L18.0852 12.9037Z", fill: color }));
}
exports["default"] = lbc;
//# sourceMappingURL=lbc.js.map